import { cliSimpleGit } from '../cli-simple-git.js';

function normalizeBranchRef(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed || trimmed === 'HEAD') return null;
  if (trimmed.startsWith('refs/heads/')) return trimmed.slice('refs/heads/'.length);
  if (trimmed.startsWith('refs/remotes/')) return trimmed.slice('refs/remotes/'.length);
  return trimmed;
}

/** Local and remote branch refs (e.g. `main`, `origin/main`), newest tip commit first. */
export async function listRepoBranchRefs(repoPath: string): Promise<string[]> {
  try {
    const git = cliSimpleGit(repoPath);
    const out = await git.raw([
      'for-each-ref',
      '--sort=-committerdate',
      '--format=%(refname:short)',
      'refs/heads',
      'refs/remotes',
    ]);
    const lines = out.split('\n').map((line) => normalizeBranchRef(line)).filter((line): line is string => Boolean(line));
    const seen = new Set<string>();
    const ordered: string[] = [];
    for (const name of lines) {
      if (seen.has(name)) continue;
      seen.add(name);
      ordered.push(name);
    }
    return ordered;
  } catch {
    return [];
  }
}
